module.exports = __webpack_public_path__ + "static/media/4.4390d0b0.jpg";